import { forwardRef } from 'react'

import { Text, theme } from '@hhgtech/hhg-components'
import { Boy, Girl } from '@hhgtech/icons/other'
import { Group } from '@mantine/core'

import { Option } from 'components/molecules/dropdownSearch'
import { BabyVaccinationDetail, Gender } from 'interfaces/types'

import { generateGender } from './helper'

export const Baby = forwardRef<
  HTMLDivElement,
  BabyVaccinationDetail['profile'] & Option
>(function Baby(
  { gender, label, ...others }: BabyVaccinationDetail['profile'] & Option,
  ref,
) {
  return (
    <div ref={ref} {...others}>
      <Group noWrap>
        {generateGender(gender) === Gender.Boy ? (
          <Boy size={24} />
        ) : (
          <Girl size={24} />
        )}
        <Text size="p2" color={theme.colors.gray800}>
          {label}
        </Text>
      </Group>
    </div>
  )
})
